module.exports = __webpack_public_path__ + "fonts/gothica1-light-webfont.e61f2bd.woff";